import { AutogenModelTariffRegionLtlZipLoc, AutogenRowTariffRegionLtlZipLoc } from "./autogen/AutogenModelTariffRegionLtlZipLoc";

export class ModelTariffRegionLtlZipLoc extends AutogenModelTariffRegionLtlZipLoc<RowTariffRegionLtlZipLoc> {
	constructor() {
		super(RowTariffRegionLtlZipLoc);
	}
}

export class RowTariffRegionLtlZipLoc extends AutogenRowTariffRegionLtlZipLoc {
}